import React, { Component } from 'react'
import './productitem.scss'

import Button from '../Button'
import Separator from '../Separator'
import Tags from '../Tags'
import Tooltip from '../Tooltip'
import Notifications from '../Notifications'

class ProductItem extends Component {
	constructor(props) {
		super(props)
		this.state = {
			notPersonalized: props.projOBJ.notPersonalized ? props.projOBJ.notPersonalized : false,
			contentClasses: props.projOBJ.notPersonalized ? 'item-content disabled' : 'item-content',
			contentType: props.projOBJ.contentOBJ.type ? props.projOBJ.contentOBJ.type : '',
			tooltipOpen: false
		}
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside)
		let activeTag = document.querySelectorAll('.vbui--tag.active .vbui--tooltip')
		console.log(activeTag)

		/*
		if(activeTag){
			activeTag.addEventListener('click', this.dropTooltip)
		}
		*/
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside)
	}

	addUnit(e) {
		let counter = parseInt(e.target.parentNode.querySelector('.counter').innerHTML)
		counter += 1
		e.target.parentNode.querySelector('.counter').innerHTML = counter
	}
	removeUnit(e) {
		let counter = parseInt(e.target.parentNode.querySelector('.counter').innerHTML)
		if (counter > 1) {
			counter -= 1
			e.target.parentNode.querySelector('.counter').innerHTML = counter
		}
	}

	dropTooltip = () => {
		console.log('click')
		this.setState({ tooltipOpen: !this.state.tooltipOpen })
	}

	setWrapperRef = (node) => {
		this.wrapperRef = node
	}

	handleClickOutside = (event) => {
		// console.log(this.wrapperRef)
		// if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
		// 	if (this.state.tooltipOpen) this.setState({tooltipOpen: false})
		// }
	}

	renderSubtitle = () => {
		if (this.state.notPersonalized) {
			return (
				<div className="subtitle-carrier">
					<div className="details-trigger">
						Qué ocurre si no personalizo
						<div className="info-hover">
							<span className="icon-icon-tooltip-2"></span>
							<Tooltip classes="northwest"></Tooltip>
						</div>
					</div>
				</div>
			)
		} else {
			return (
				<div className="subtitle-carrier">
					<p className="subtitle">{this.props.projOBJ.subtitle}</p>
				</div>
			)
		}
	}

	renderContent = () => {
		const content = this.props.projOBJ.contentOBJ.content
		switch (this.state.contentType) {
			case 'details':
				return (
					<div className="content-list">
						<div className="content-row">
							<div className="title-col content-col">
								<p>Cantidad</p>
							</div>
							<div className="info-col content-col">
								<div className="quantity-counter">
									<div className="btn minus-btn" onClick={(e) => this.removeUnit(e)}>
										<span className="icon-icon-minus"></span>
									</div>
									<div className="counter">{content.quantity}</div>
									<div className="btn plus-btn" onClick={(e) => this.addUnit(e)}>
										<span className="icon-icon-plus"></span>
									</div>
								</div>
							</div>
						</div>
						<div className="content-row">
							<div className="title-col content-col">
								<p>Acabado</p>
							</div>
							<div className="info-col content-col">
								<p>{content.finish}</p>
							</div>
						</div>
						<div className="content-row">
							<div className="title-col content-col">
								<p>Temperatura</p>
							</div>
							<div className="info-col content-col">
								<p>{content.temp}</p>
							</div>
						</div>
						<div className="content-row">
							<div className="title-col content-col">
								<p>Dimming</p>
							</div>
							<div className="info-col content-col">
								<p>{content.dimming}</p>
							</div>
						</div>
						<div className="content-row">
							<div className="title-col content-col">
								<p>Lumens</p>
							</div>
							<div className="info-col content-col">
								<p>{content.lumens}</p>
							</div>
						</div>
						<div className="content-row">
							<div className="title-col content-col">
								<p>Watts</p>
							</div>
							<div className="info-col content-col">
								<p>{content.watts}</p>
							</div>
						</div>
						<div className="content-row">
							<div className="title-col content-col">
								<p>Altura</p>
							</div>
							<div className="info-col content-col">
								<p>{content.height}</p>
							</div>
						</div>
					</div>
				)
			case 'list':
				if (content.length < 8) {
					return (
						<div className="content-list">
							{content.map((row, i) => {
								return (
									<div key={i} className="content-row">
										<div className="title-col content-col">
											<p>{row.title}</p>
										</div>
										<div className="info-col content-col">
											<p>{row.text}</p>
										</div>
									</div>
								)
							})}
						</div>
					)
				} else {
					const remainingItems = content.length - 6
					return (
						<div className="content-list">
							{content.map((row, i) => {
								if (i < 6) {
									return (
										<div key={i} className="content-row">
											<div className="title-col content-col">
												<p>{row.title}</p>
											</div>
											<div className="info-col content-col">
												<p>{row.text}</p>
											</div>
										</div>
									)
								} else {
									return false
								}
							})}
							<div className="hidden-elements">
								<p>{remainingItems} más...</p>
							</div>
						</div>
					)
				}
			default:
				return <div>No hay nada que mostrar aquí</div>
		}
	}

	render() {
		let classes = ['vbui--productitem', this.props.classes, this.props.state].join(' ')
		let show = this.state.isOpen ? 'show' : ''
		const specialTooltipClasses = ['northwest', show].join(' ')
		return (
			<div className={classes}>
				<div className="item-header">
					<div className="img-container">
						<img src={this.props.projOBJ.imgUrl} alt="" />
					</div>
					<div className="item-extra-info">
						{this.props.projOBJ.tags && (
							<div className="tags-container">
								{this.props.projOBJ.tags.map((tag, i) => {
									if (tag.special) {
										return (
											<div key={i}>
												<Tags state={tag.active} special={tag.special} onClick={this.dropTooltip}>
													{tag.tagCont}
												</Tags>
												<Tooltip classes={specialTooltipClasses}>
													<div>
														<p className="title tooltip-title">
															Este producto tiene opciones de configuración especiales diferentes a las standard en:
														</p>
														<ul>
															<li>Acabados</li>
															<li>Temperatura de color LED</li>
														</ul>
														<Button classes="fill large">Ver producto y opciones configuración</Button>
														<Button classes="ghost large" showIcon={true} icon="icon-icon-support">
															Pide soporte para este producto
														</Button>
													</div>
												</Tooltip>
											</div>
										)
									} else {
										return (
											<Tags key={i} state={tag.active}>
												{tag.tagCont}
											</Tags>
										)
									}
								})}
							</div>
						)}
						{this.state.notPersonalized && (
							<div className="msg-container">
								<Notifications classes="thin" state={this.props.projOBJ.msg.lvl}>
									{this.props.projOBJ.msg.msg}
								</Notifications>
							</div>
						)}
					</div>

					<div className="item-title-block">
						<p className="item-title">{this.props.projOBJ.title}</p>
						{this.renderSubtitle()}
					</div>
				</div>
				<div className={this.state.contentClasses}>{this.renderContent()}</div>
				<div className="item-footer">
					<div className="btn-container">
						<Button classes="ghost medium" showIcon={true} icon="icon-icon-edit"></Button>
						<Button classes="ghost medium" showIcon={true} icon="icon-icon-download"></Button>
						<Button classes="ghost medium" showIcon={true} icon="icon-icon-duplicate"></Button>
						<Button classes="ghost medium" showIcon={true} icon="icon-icon-delete"></Button>
					</div>
					<Separator classes="medium pink"></Separator>
				</div>
			</div>
		)
	}
}

export default ProductItem
